import { Button, List, ListItem, Typography } from '@mui/material';
import { createTheme } from "@mui/material/styles";
import { makeStyles, ThemeProvider } from '@mui/styles';
import PropTypes from 'prop-types';
import React from 'react';

// Create a theme with spacing
const theme = createTheme({
  spacing: 8,
});

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const SidebarNav = ({ project }) => {
  const classes = useStyles();

  if (!project) {
    return <Typography>Loading...</Typography>;
  }

  const listItems = project?.list || [];

  return (
    <List>
      {listItems.map((item) => (
        <ListItem key={item.path}>
          <Button className={classes.button}>
            {item.title}
          </Button>
        </ListItem>
      ))}
    </List>
  );
};

const App = () => (
  <ThemeProvider theme={theme}>
    <SidebarNav project={{ list: [{ path: '/home', title: 'Home' }] }} />
  </ThemeProvider>
);

SidebarNav.propTypes = {
  project: PropTypes.shape({
    list: PropTypes.arrayOf,
  })
}

export default App;
